import { createFileRoute } from "@tanstack/react-router";
import DebitNotesConfigurations from "@/components/invoices/debits/configuration/debit-notes-configuration";
import InvoicesConfigurationNavigation from "@/components/invoices/configuration/invoices-configuration-navigation";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/settings/_layout/invoices/debit-notes")({
  component: DebitNotesSettingsPage,
});

function DebitNotesSettingsPage() {
  return (
    <RouteGuardPermissions permissions={[{ module: "debit_notes_configurations", actions: ["read", "update"] }]}>
      <div className="gap-4 flex-col flex">
        <InvoicesConfigurationNavigation />
        <DebitNotesConfigurations module="debit_notes_configurations" />
      </div>
    </RouteGuardPermissions>
  );
}
